import * as React from 'react';
import './month-input.scss';
import DatePicker, { registerLocale } from 'react-datepicker';
import ko from 'date-fns/locale/ko';

registerLocale('ko', ko);

interface Props {
  onChange: Function;
  value?: Date;
  typeText?: boolean;
}

const MonthInput: React.FunctionComponent<Props> = ({ onChange, typeText, value = new Date() }) => {
  const ref = React.useRef() as any;

  const ExampleCustomInput = React.forwardRef(({ value, onClick, onChange }: any, ref: any) => (
    <input value={value} className="month-picker__custom-input" onClick={onClick} onChange={onChange} ref={ref}></input>
  ));

  return (
    <div className="month-picker">
      <DatePicker
        locale={'ko'}
        selected={value}
        onChange={(date) => date && onChange(date)}
        customInput={<ExampleCustomInput />}
        showMonthYearPicker
        dateFormat={typeText ? 'yyyy년 MM월' : 'yyyy.MM'}
      />
    </div>
  );
};
export default MonthInput;
